// API base URL.
// - Override a RUNTIME: window.__API_URL__ (da public/config.js) per puntare a un
//   backend remoto senza ricompilare. Se non impostato -> comportamento di default:
// - Dev server (npm start, porta 3010/3000): parla col backend diretto su :8002
// - Produzione dietro nginx (porte 80/443): stesso origin, path /api (proxato da nginx)
const { protocol, hostname, port } = window.location;
const isDevServer = port === '3010' || port === '3000';

const fallback = isDevServer
  ? `http://${hostname}:8002/api`
  : `${protocol}//${hostname}${port ? ':' + port : ''}/api`;

// window.__API_URL__ ha la precedenza (se valorizzato); altrimenti il fallback sopra.
export const API = (typeof window !== 'undefined' && window.__API_URL__) || fallback;
